export default {
    setMessages(state,payload){
        state.messages = payload;
    }
}